import FAIL_ICON_URL from '@src/js/lzimg/fail-image-icon.svg';

const DEFAULT_SIZE = 500;

/**
 * 生成错误占位图的 data-url
 * 这里会根据图片尺寸自适应样式，逻辑是：
 * 1. 长宽不足以放入文本时，只展示图标；
 * 2. 长宽较小时，缩放文本的大小；
 * 3. 其他情况，正常显示
 * @param text 占位图的文本
 * @param width 占位图的宽度
 * @param height 占位图的长度
 * @returns 占位图的 data-url
 */
function generateFailImageUrl(text: string, width: number = DEFAULT_SIZE, height: number = DEFAULT_SIZE): string {
    const size = Math.min(width, height);
    const iconSize = size / 4;
    const fontSize = size / 16;

    return svg2url(generateFailSVG({ width, height, iconSize, fontSize, text, showText: fontSize > 12 }));
}

function generateFailSVG({
    width, height, iconSize, fontSize, text, showText,
}: {
    width: number;
    height: number;
    iconSize: number;
    fontSize: number;
    text: string;
    showText: boolean;
}) {
    return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${width} ${height}">
            <rect width="100%" height="100%" fill="#f9fafb" />
            <image x="50%" y="50%" transform="translate(-${iconSize / 2} -${iconSize * (showText ? 0.75 : 0.5)})" width="${iconSize}" height="${iconSize}" href="${FAIL_ICON_URL}" />
            ${showText ? `<text x="50%" y="50%" transform="translate(0 ${(iconSize / 4) + fontSize})" dominant-baseline="middle" text-anchor="middle" font-size="${fontSize}" fill="#c2c2c2" font-family="system-ui">${text}</text>`  : ''}
        </svg>
    `;
}

function svg2url(svg: string) {
    return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`;
}

export { FAIL_ICON_URL, generateFailImageUrl };
